<template>
  <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 24 24">
    <path
      d="M7,22c-.6,0-1-.2-1.4-.6-.4-.4-.6-.9-.6-1.4s.2-1,.6-1.4c.4-.4.9-.6,1.4-.6s1,.2,1.4.6c.4.4.6.9.6,1.4s-.2,1-.6,1.4c-.4.4-.9.6-1.4.6ZM17,22c-.5,0-1-.2-1.4-.6-.4-.4-.6-.9-.6-1.4s.2-1,.6-1.4c.4-.4.9-.6,1.4-.6s1,.2,1.4.6c.4.4.6.9.6,1.4s-.2,1-.6,1.4c-.4.4-.9.6-1.4.6ZM6.2,6l2.4,5h7l2.7-5H6.2ZM5.2,4h14.8c.4,0,.7.2.9.5.2.3.2.7,0,1l-3.6,6.4c-.2.3-.4.6-.7.8s-.6.3-1,.3h-7.4l-1.1,2h12v2H7c-.8,0-1.3-.3-1.7-1-.4-.7-.4-1.3,0-2l1.3-2.4-3.6-7.6H1v-2h3.2l.9,2Z"
    />
  </svg>
</template>
